import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SitesContractorsComponent } from './sites-contractors/sites-contractors.component';
import { SitesHazardousSubstancesComponent } from './sites-hazardous-substances/sites-hazardous-substances.component';
import { SitesManagersComponent } from './sites-managers/sites-managers.component';
import { SitesLayoutComponent } from './sites-layout/sites-layout.component';
import { SitesToolboxTalksComponent } from './sites-toolbox-talks/sites-toolbox-talks.component';
import { SitesComponent } from './sites/sites/sites.component';
import { SitesCodesComponent } from './sites-codes/sites-codes.component';
import { SitesTaskAnalysesComponent } from './sites-task-analyses/sites-task-analyses.component';
import { AuthGuard } from '../guards/auth.guard';
import { SitesMainSsspComponent } from './sites-main-sssp/sites-main-sssp.component';
import { SitesSafetyObservationsComponent } from './sites-safety-observations/sites-safety-observations.component';
import {SitesTaskAnalysesRevisedComponent} from "./sites-task-analyses-revised/sites-task-analyses-revised/sites-task-analyses-revised.component";
import {SitesTaskAnalysesRevisedTabsComponent} from "./sites-task-analyses-revised/sites-task-analyses-revised-tabs/sites-task-analyses-revised-tabs.component";
import { SitesDynamicFormsComponent } from './sites-dynamic-forms/sites-dynamic-forms.component';
import { SitesAuditsEditComponent } from './sites-audits-edit/sites-audits-edit.component';
import { SitesAuditsComponent } from './sites-audits/sites-audits.component';
import { SitesAuditsViewComponent } from './sites-audits-view/sites-audits-view.component';
import { SitesIncidentsComponent } from './sites-incidents/sites-incidents.component';
import {SitesToolboxTalksTabsComponent} from "./sites-toolbox-talks-tabs/sites-toolbox-talks-tabs.component";
import {SitesImporterComponent} from "./sites-importer/sites-importer.component";
import {SitesChildrenComponent} from "./sites/sites-children/sites-children.component";
import {SitesCodesEditComponent} from "./sites-codes/codes-edit/sites-codes-edit.component";
import {SitesCodesViewComponent} from "./sites-codes/codes-view/sites-codes-view.component";
import {SitesUsersWorkedOnComponent} from "./sites-users-worked-on/sites-users-worked-on.component";
import {
  SitesNotificationsTabsComponent
} from './sites-notificaions/sites-notifications-tabs/sites-notifications-tabs.component';
import { RBACGuard } from '../guards/rbac.guard';
import { RBACService } from '../shared/rbac.service';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import { SitesDetailsLayoutComponent } from './sites/sites-details-layout/sites-details-layout.component';
import { SitesNoticeboardLayoutComponent } from './sites/sites-noticeboard-layout/sites-noticeboard-layout.component';
import { SitesEepLayoutComponent } from './sites/sites-eep/sites-eep-layout/sites-eep-layout.component';
import { SitesDocsComponent } from './sites-docs/sites-docs.component';
import { SitesHazardsComponent } from './sites-hazards/sites-hazards/sites-hazards.component';
import { SitesAssetsComponent } from "./sites-assets/sites-assets.component";

const componentRoutes = [
  {
    path: 'details',
    component: SitesDetailsLayoutComponent,
    canActivate: [
      AuthGuard,
      RBACGuard
    ],
    data: {
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT)
      ],
      exact: false
    }
  },
  {
    path: 'noticeboard',
    component: SitesNoticeboardLayoutComponent,
    canActivate: [
      AuthGuard,
      RBACGuard
    ],
    data: {
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT)
      ],
      exact: false
    }
  },
  // Site Sub-Safety Plans (contractors) is part of the SAFETY_PLANS feature area.
  { path: 'contractors', component: SitesContractorsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SAFETY_PLANS } },
  // Managers and Users Worked On ARE the SITES feature; the site context is only reachable via the SITES gate.
  { path: 'managers', component: SitesManagersComponent },
  { path: 'hazards', component: SitesHazardsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.HAZARDS } },
  { path: 'hazardous-substances', component: SitesHazardousSubstancesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.HAZARDOUS_SUBSTANCES } },
  { path: 'toolbox-talks', component: SitesToolboxTalksComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TOOLBOX_TALKS } },
  { path: 'toolbox-talks/:toolbox_talk_id/view', component: SitesToolboxTalksTabsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TOOLBOX_TALKS } },
  { path: 'folders', component: SitesDocsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.DOCUMENTS } },
  { path: 'codes', component: SitesCodesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.QR_CODES } },
  { path: 'codes/:code_id/edit', component: SitesCodesEditComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.QR_CODES } },
  { path: 'codes/:code_id/view', component: SitesCodesViewComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.QR_CODES } },
  {
    path: 'emergency-evacuation-plans',
    component: SitesEepLayoutComponent,
    canActivate: [
      AuthGuard,
      PlanGuard,
      RBACGuard
    ],
    data: {
      planFeature: AppService.FEATURES.EMERGENCY_EVACUATION_PLAN,
      // EEP View OR Edit, matching the site menu. This route is mounted under both the site `view`
      // and `edit` paths, so it must admit view-only users. sites:view is implied by the site
      // context; edit mode (which also needs sites:edit to save) is enforced in SitesEepEditComponent.
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES_EEP, RBACService.RBAC_A.A_VIEW),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES_EEP, RBACService.RBAC_A.A_EDIT)
      ],
      exact: false
    }
  },
  { path: 'task-analyses', component: SitesTaskAnalysesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TASK_ANALYSIS } },
  { path: 'task-analyses-revised', component: SitesTaskAnalysesRevisedComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TASK_ANALYSIS } },
  { path: 'task-analyses-revised/:ta_revised_id/edit', component: SitesTaskAnalysesRevisedTabsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TASK_ANALYSIS } },
  { path: 'task-analyses-revised/:ta_revised_id/view', component: SitesTaskAnalysesRevisedTabsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TASK_ANALYSIS } },
  { path: 'sssp-config', component: SitesMainSsspComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SAFETY_PLANS } },
  { path: 'safety-observations', component: SitesSafetyObservationsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SAFETY_OBSERVATIONS } },
  { path: 'incidents', component: SitesIncidentsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.INCIDENTS } },
  { path: 'dynamic-forms', component: SitesDynamicFormsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.FORMS } },
  { path: 'audits', component: SitesAuditsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.INSPECTIONS_AUDITS } },
  { path: 'audits/:audit_id/edit', component: SitesAuditsEditComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.INSPECTIONS_AUDITS } },
  { path: 'audits/:audit_id/view', component: SitesAuditsViewComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.INSPECTIONS_AUDITS } },
  { path: 'users-worked-on', component: SitesUsersWorkedOnComponent },
  // Notifications (notification roles) is a Premium feature.
  { path: 'notifications', component: SitesNotificationsTabsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.NOTIFICATION_ROLES } },
  { path: 'assets', component: SitesAssetsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.ASSETS } }
];

const routes: Routes = [
  {
    path: 'sites',
    component: SitesComponent,
    canActivate: [
      AuthGuard,
      PlanGuard,
      RBACGuard
    ],
    data: {
      planFeature: AppService.FEATURES.SITES,
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW)
      ],
      exact: false
    }
  },
  {
    path: 'sites/importer',
    component: SitesImporterComponent,
    canActivate: [
      AuthGuard,
      PlanGuard,
      RBACGuard
    ],
    data: {
      planFeature: AppService.FEATURES.SITES,
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE)
      ],
      exact: false
    }
  },
  {
    path: 'sites/:parent_id',
    canActivate: [
      AuthGuard,
      PlanGuard,
      RBACGuard
    ],
    data: {
      planFeature: AppService.FEATURES.SITES,
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
        RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW)
      ],
      exact: false
    },
    children: [
      {
        path: 'children',
        component: SitesChildrenComponent,
        canActivate: [
          AuthGuard,
          RBACGuard
        ],
        data: {
          permissions: [
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW)
          ],
          exact: false
        }
      },
      {
        path: 'children/:child_id',
        canActivate: [
          AuthGuard,
          RBACGuard
        ],
        data: {
          permissions: [
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW)
          ],
          exact: false
        },
        children: [
          {
            path: 'edit',
            component: SitesLayoutComponent,
            children: componentRoutes,
            canActivate: [
              AuthGuard,
              RBACGuard
            ],
            data: {
              permissions: [
                RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
                RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT)
              ],
              exact: false
            }
          },
          {
            path: 'view',
            component: SitesLayoutComponent,
            children: componentRoutes,
            canActivate: [
              AuthGuard,
              RBACGuard
            ],
            data: {
              permissions: [
                RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW)
              ],
              exact: false
            }
          }
        ]
      },
      {
        path: 'edit',
        component: SitesLayoutComponent,
        children: componentRoutes,
        canActivate: [
          AuthGuard,
          RBACGuard
        ],
        data: {
          permissions: [
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW),
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT)
          ],
          exact: false
        }
      },
      {
        path: 'view',
        component: SitesLayoutComponent,
        children: componentRoutes,
        canActivate: [
          AuthGuard,
          RBACGuard
        ],
        data: {
          permissions: [
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_CREATE),
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_VIEW),
            RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT)
          ],
          exact: false
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SitesRoutingModule {}
